export { default } from '@shikijs/langs/ssh-config'
